import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Globe } from 'lucide-react';
import './District.css'; // You can copy Department.css if styles are the same
// const url = import.meta.env.VITE_BACKEND_URL;
const url = process.env.REACT_APP_BACKEND_URL;

const EditDistrict = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: ""
  });

  useEffect(() => {
    const fetchDistrict = async () => {
      try {
        const response = await axios.get(`${url}/api/district/${id}`);
        setData({
          name: response.data.data.name
        });
      } catch (error) {
        toast.error("Failed to load District data");
        navigate('/ViewDistrict');
      }
    };

    fetchDistrict();
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await axios.put(
        `${url}/api/district/${id}`,
        data
      );

      if (response.data.success) {
        toast.success("District updated successfully!");
        navigate('/ViewDistrict');
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update District");
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  return (
    <div className="form-wrapper">
      <div className="district-form-container">
        <h2 className="form-title">
          <Globe size={20} className="inline mr-2" /> Edit District
        </h2>
        
        <form className="district-form" onSubmit={handleSubmit}>
          <div className="form-field filled">
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={handleChange}
              required
            />
            <label>District Name</label>
          </div>

          <div className="button-group">
            <button
              type="button"
              className="cancel-btn"
              onClick={() => navigate('/ViewDistrict')}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={submitting}
            >
              {submitting ? "Updating..." : "Update District"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditDistrict;
